<template>
  <div>
    <p>Oauth Callback</p>
  </div>
</template>

<script>
export default {
  methods: {},
};
</script>
